// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"a307ed52","129":"7d794094","253":"0d61fccd","789":"b9be8079","833":"1f75c7cf","851":"6c88e3e2","856":"4f05143f","928":"6ba40317"}[chunkId] + ".chunk.css";
};